var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-panel',[(_vm.loading)?_c('div',{staticClass:"pt-5",staticStyle:{"text-align":"center"}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"indeterminate":""}})],1):_c('task-form-auto-steps',{attrs:{"task-type":_vm.data.taskType,"previous-form-data":_vm.formData,"show-destinations":_vm.data.destinationType !== 'custom'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }